import type { OrganizationType } from "../types/organization.type";
import {
  getReportSectionsForOrgType,
  sanitizeReportSections,
  type ReportPdfSectionId,
} from "../constants/reportCustomize.catalog";

const STORAGE_KEY = "reportPreferences";

interface StoredReportPreferences {
  selectedSections?: unknown;
}

function readStored(): StoredReportPreferences | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredReportPreferences;
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export function loadReportPreferences(
  orgType: OrganizationType,
): ReportPdfSectionId[] {
  const stored = readStored();
  if (!stored) return getReportSectionsForOrgType(orgType);
  return sanitizeReportSections(stored.selectedSections, orgType);
}

export function saveReportPreferences(selectedSections: ReportPdfSectionId[]): void {
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ selectedSections } satisfies StoredReportPreferences),
  );
}
